module.exports = __webpack_public_path__ + "img/capabilities.978a072e.jpg";